const SUBSCRIPTION_TIER_LABELS = {
  'Free': 'The Channel',
  'No G': 'The Channel',
  'No G Shop': 'The Channel',
  'No-G Shop': 'The Channel',
  'OG': 'Cosmic Connections',
  'OG Shop': 'Cosmic Connections',
  'Super OG': 'Altered States',
  'Super OG Shop': 'Altered States',
};

export const formatSubscriptionTierLabel = (tier = '') => {
  const normalizedTier = String(tier || '').trim();

  return SUBSCRIPTION_TIER_LABELS[normalizedTier] || normalizedTier;
};